/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SORTABLE
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	sortable: {
		'& .errormessage': {
			margin: pxToEm(10)
		}
	}
});